import { Helper } from '../../Helper';
export class OmitObjectPropertiesHelperBase extends Helper {
    emit(sb, node, options) {
        const objectValName = sb.scope.addUnique();
        sb.emitOp(node, 'SWAP');
        sb.scope.set(sb, node, options, objectValName);
        sb.emitHelper(node, options, sb.helpers.arrForEach({
            each: () => {
                sb.scope.get(sb, node, options, objectValName);
                sb.emitHelper(node, options, this.getObject(sb));
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'REMOVE');
            },
        }));
    }
}

//# sourceMappingURL=OmitObjectPropertiesHelperBase.js.map
